import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "./theme/variables.css";

import { useDispatch } from 'react-redux';
import type { AppDispatch } from './redux/store';
import { useEffect } from 'react';

import { IonApp, IonHeader, IonToolbar, setupIonicReact } from "@ionic/react";
import { BrowserRouter, useLocation } from "react-router-dom";

import BcStoreManager from "app/bigcommerce/components/BcStoreManager";
import EnvironmentNotification from "components/EnvironmentNotification/EnvironmentNotification";
import GlobalStyles from "./theme/globalStyles";
import Header from "components/header/Header";
import LocaleManager from "LocaleMananger";
import Navbar from "components/nav/Navbar/Navbar";
import PostMessageHandlers from "components/postMessage/PostMessageHandlers";
import Routing from "components/routing/Routing";
import WordPressManager from "app/wordpress/components/WordPressManager";
import { init } from "app/i18n";
import useIosTrackingConsent from "hooks/useIosTrackingConsent";
import { fetchIdentifierFromStorage } from './redux/auth/authSlice';

setupIonicReact();
init("en");

const App = () => {
  const dispatch = useDispatch<AppDispatch>();
  useIosTrackingConsent();

  useEffect(() => {
    dispatch(fetchIdentifierFromStorage());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <IonApp>
        <GlobalStyles />

        <ConditionalHeader />

        <Routing />

        <LocaleManager>
          <BcStoreManager>
            <WordPressManager />
          </BcStoreManager>
        </LocaleManager>

        <PostMessageHandlers />
      </IonApp>
    </BrowserRouter>
  );
};

export default App;

/* ---------------------------- */
/* Header component that hides on certain pages */
const ConditionalHeader: React.FC = () => {
  const location = useLocation();

  return (
    <IonHeader className="ion-no-border">
      <EnvironmentNotification />
      <IonToolbar>
        <Header />
        <Navbar />
      </IonToolbar>
    </IonHeader>
  );
};
